import {
  useGetAziende,
  useGetAziendePortale,
  useGetNodo,
  useGetNodoPortale,
} from "@/api";
import { useAuth } from "@/context/useAuth";
import { portaleConfig } from "@/portaliConfig";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import LoadingError from "../LoadingError";
import NodoCard from "../NodoCard";

function HomePageUtenteEsterno() {
  const { user } = useAuth();
  const { t } = useTranslation();

  const {
    isLoading: isLoadingAziende,
    error: errorAzienda,
    data: aziendeData,
  } = useGetAziendePortale(portaleConfig.id);

  const shouldFetchNodi = aziendeData?.data?.length === 1;
  const {
    isLoading: isLoadingNodi,
    error: errorNodi,
    data: nodiData,
  } = useGetNodoPortale(portaleConfig.id, aziendeData?.data?.[0]?.id ?? 0, {
    query: {
      enabled: shouldFetchNodi,
    },
  });

  if (isLoadingAziende || (shouldFetchNodi && isLoadingNodi)) {
    return <Loading />;
  }

  if (errorAzienda) {
    return <LoadingError error={errorAzienda} />;
  } else if (errorNodi) {
    return <LoadingError error={errorNodi} />;
  }

  const nodiDaMostrare =
    shouldFetchNodi
      ? nodiData?.data?.nodiFigli ?? []
      : aziendeData.data;

  return (
    <Box p={2}>
      <Box
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: "46px" }}
      >
        <Typography variant="h4" mr={2}>
          {t("homePageUtenteEsterno.benvenuto", {
            nome: user?.name,
            cognome: user?.lastName,
          })}
        </Typography>
      </Box>

      <Box
        mt={2}
        mb={0}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        gap={2}
      >
        {nodiDaMostrare.map((n) => {
          return <NodoCard key={n.id} nodo={n} />;
        })}
      </Box>
    </Box>
  );
}

export default HomePageUtenteEsterno;
